require("core-js/modules/es6.array.fill");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.assign");

!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports, require("react"), require("prop-types"), require("d3-geo"), require("topojson-client"), require("d3-zoom"), require("d3-selection")) : "function" == typeof define && define.amd ? define(["exports", "react", "prop-types", "d3-geo", "topojson-client", "d3-zoom", "d3-selection"], t) : t((e = e || self).reactSimpleMaps = e.reactSimpleMaps || {}, e.React, e.PropTypes, e.d3, e.topojson, e.d3, e.d3);
}(this, function (e, t, o, n, r, a, s) {
  "use strict";

  var i = "default" in t ? t.default : t;
  o = o && o.hasOwnProperty("default") ? o.default : o;

  var c = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var o = arguments[t];

      for (var n in o) {
        Object.prototype.hasOwnProperty.call(o, n) && (e[n] = o[n]);
      }
    }

    return e;
  },
      u = function u(e, t) {
    var o = {};

    for (var n in e) {
      t.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(e, n) && (o[n] = e[n]);
    }

    return o;
  },
      l = function l(e, t) {
    if (Array.isArray(e)) return e;
    if (Symbol.iterator in Object(e)) return function (e, t) {
      var o = [],
          n = !0,
          r = !1,
          a = void 0;

      try {
        for (var s, i = e[Symbol.iterator](); !(n = (s = i.next()).done) && (o.push(s.value), !t || o.length !== t); n = !0) {
          ;
        }
      } catch (e) {
        r = !0, a = e;
      } finally {
        try {
          !n && i.return && i.return();
        } finally {
          if (r) throw a;
        }
      }

      return o;
    }(e, t);
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  },
      f = n.geoPath,
      p = u(n, ["geoPath"]),
      d = t.createContext(),
      m = function m(e) {
    var o = e.width,
        n = e.height,
        r = e.projection,
        a = e.projectionConfig,
        s = u(e, ["width", "height", "projection", "projectionConfig"]),
        m = a.center || [],
        v = l(m, 2),
        h = v[0],
        g = v[1],
        y = a.rotate || [],
        M = l(y, 3),
        E = M[0],
        j = M[1],
        x = M[2],
        k = a.parallels || [],
        b = l(k, 2),
        N = b[0],
        w = b[1],
        C = a.scale || null,
        S = t.useMemo(function () {
      return function (e) {
        var t = e.projectionConfig,
            o = void 0 === t ? {} : t,
            n = e.projection,
            r = void 0 === n ? "geoEqualEarth" : n,
            a = e.width,
            s = void 0 === a ? 800 : a,
            i = e.height,
            c = void 0 === i ? 600 : i;
        if ("function" == typeof r) return r;
        var u = p[r]().translate([s / 2, c / 2]);
        return [u.center ? "center" : null, u.rotate ? "rotate" : null, u.scale ? "scale" : null, u.parallels ? "parallels" : null].forEach(function (e) {
          e && (u = u[e](o[e] || u[e]()));
        }), u;
      }({
        projectionConfig: {
          center: h || 0 === h || g || 0 === g ? [h, g] : null,
          rotate: E || 0 === E || j || 0 === j ? [E, j, x] : null,
          parallels: N || 0 === N || w || 0 === w ? [N, w] : null,
          scale: C
        },
        projection: r,
        width: o,
        height: n
      });
    }, [o, n, r, h, g, E, j, x, N, w, C]),
        T = t.useCallback(S, [S]),
        O = t.useMemo(function () {
      return {
        width: o,
        height: n,
        projection: T,
        path: f().projection(T)
      };
    }, [o, n, T]);
    return i.createElement(d.Provider, c({
      value: O
    }, s));
  };

  m.propTypes = {
    width: o.number,
    height: o.number,
    projection: o.oneOfType([o.string, o.func]),
    projectionConfig: o.object
  };

  var v = function v(e) {
    var t = e.width,
        o = void 0 === t ? 800 : t,
        n = e.height,
        r = void 0 === n ? 600 : n,
        a = e.projection,
        s = void 0 === a ? "geoEqualEarth" : a,
        l = e.projectionConfig,
        f = void 0 === l ? {} : l,
        p = e.className,
        d = void 0 === p ? "" : p,
        v = u(e, ["width", "height", "projection", "projectionConfig", "className"]);
    return i.createElement(m, {
      width: o,
      height: r,
      projection: s,
      projectionConfig: f
    }, i.createElement("svg", c({
      viewBox: "0 0 " + o + " " + r,
      className: "rsm-svg " + d
    }, v)));
  };

  function h(e, t, o) {
    var n = (e * o.k - e) / 2,
        r = (t * o.k - t) / 2;
    return [e / 2 - (n + o.x) / o.k, t / 2 - (r + o.y) / o.k];
  }

  function g(e, t) {
    if (Array.isArray(e)) return t ? t(e) : e;
    var o = r.feature(e, e.objects[Object.keys(e.objects)[0]]).features;
    return t ? t(o) : o;
  }

  function y(e) {
    var o = e.geography,
        n = e.parseGeographies,
        r = t.useContext(d).path,
        a = t.useState(),
        s = l(a, 2),
        i = s[0],
        u = s[1];
    return t.useEffect(function () {
      var e;
      "undefined" != typeof window && ("string" == typeof o ? (e = o, fetch(e).then(function (e) {
        if (!e.ok) throw Error(e.statusText);
        return e.json();
      }).catch(function (e) {
        console.log("There was a problem when fetching the data: ", e);
      })).then(function (e) {
        e && u(g(e, n));
      }) : u(g(o, n)));
    }, [o, n]), {
      geographies: t.useMemo(function () {
        return function (e, t) {
          return e ? e.map(function (e, o) {
            return c({}, e, {
              rsmKey: "geo-" + o,
              svgPath: t(e)
            });
          }) : [];
        }(i, r);
      }, [i, r])
    };
  }

  v.propTypes = {
    width: o.number,
    height: o.number,
    projection: o.oneOfType([o.string, o.func]),
    projectionConfig: o.object,
    className: o.string
  };

  var M = function M(e) {
    var o = e.geography,
        n = e.children,
        r = e.parseGeographies,
        a = e.className,
        s = void 0 === a ? "" : a,
        l = u(e, ["geography", "children", "parseGeographies", "className"]),
        f = t.useContext(d),
        p = f.path,
        m = f.projection,
        v = y({
      geography: o,
      parseGeographies: r
    }).geographies;
    return i.createElement("g", c({
      className: "rsm-geographies " + s
    }, l), v && v.length > 0 && n({
      geographies: v,
      path: p,
      projection: m
    }));
  };

  M.propTypes = {
    geography: o.oneOfType([o.string, o.object, o.array]),
    children: o.func,
    parseGeographies: o.func,
    className: o.string
  };

  var E = function E(e) {
    var o = e.geography,
        n = e.onMouseEnter,
        r = e.onMouseLeave,
        a = e.onMouseDown,
        s = e.onMouseUp,
        f = e.onFocus,
        p = e.onBlur,
        d = e.style,
        m = void 0 === d ? {} : d,
        v = e.className,
        h = void 0 === v ? "" : v,
        g = u(e, ["geography", "onMouseEnter", "onMouseLeave", "onMouseDown", "onMouseUp", "onFocus", "onBlur", "style", "className"]),
        y = t.useState(!1),
        M = l(y, 2),
        E = M[0],
        j = M[1],
        x = t.useState(!1),
        k = l(x, 2),
        b = k[0],
        N = k[1];
    return i.createElement("path", c({
      tabIndex: "0",
      className: "rsm-geography " + h,
      d: o.svgPath,
      onMouseEnter: function onMouseEnter(e) {
        N(!0), n && n(e);
      },
      onMouseLeave: function onMouseLeave(e) {
        N(!1), E && j(!1), r && r(e);
      },
      onFocus: function onFocus(e) {
        N(!0), f && f(e);
      },
      onBlur: function onBlur(e) {
        N(!1), E && j(!1), p && p(e);
      },
      onMouseDown: function onMouseDown(e) {
        j(!0), a && a(e);
      },
      onMouseUp: function onMouseUp(e) {
        j(!1), s && s(e);
      },
      style: m[E || b ? E ? "pressed" : "hover" : "default"]
    }, g));
  };

  E.propTypes = {
    geography: o.object,
    onMouseEnter: o.func,
    onMouseLeave: o.func,
    onMouseDown: o.func,
    onMouseUp: o.func,
    onFocus: o.func,
    onBlur: o.func,
    style: o.object,
    className: o.string
  };

  var j = t.memo(E),
      x = function x(e) {
    var o = e.fill,
        r = void 0 === o ? "transparent" : o,
        a = e.stroke,
        s = void 0 === a ? "currentcolor" : a,
        l = e.step,
        f = void 0 === l ? [10, 10] : l,
        p = e.className,
        m = void 0 === p ? "" : p,
        v = u(e, ["fill", "stroke", "step", "className"]),
        h = t.useContext(d).path;
    return i.createElement("path", c({
      d: h(n.geoGraticule().step(f)()),
      fill: r,
      stroke: s,
      className: "rsm-graticule " + m
    }, v));
  };

  x.propTypes = {
    fill: o.string,
    stroke: o.string,
    step: o.array,
    className: o.string
  };
  var k = t.memo(x);

  function b(e) {
    var o = e.center,
        n = e.filterZoomEvent,
        r = e.onMoveStart,
        i = e.onMoveEnd,
        c = e.onMove,
        u = e.translateExtent,
        f = void 0 === u ? [[-1 / 0, -1 / 0], [1 / 0, 1 / 0]] : u,
        p = e.scaleExtent,
        m = void 0 === p ? [1, 8] : p,
        v = e.zoom,
        g = void 0 === v ? 1 : v,
        y = t.useContext(d),
        M = y.width,
        E = y.height,
        j = y.projection,
        x = l(o, 2),
        k = x[0],
        b = x[1],
        N = t.useState({
      x: 0,
      y: 0,
      k: 1
    }),
        w = l(N, 2),
        C = w[0],
        S = w[1],
        T = t.useRef({
      x: 0,
      y: 0,
      k: 1
    }),
        O = t.useRef(),
        P = t.useRef(),
        z = t.useRef(!1),
        Z = l(f, 2),
        G = Z[0],
        L = Z[1],
        B = l(G, 2),
        F = B[0],
        q = B[1],
        D = l(L, 2),
        U = D[0],
        W = D[1],
        A = l(m, 2),
        R = A[0],
        I = A[1];
    return t.useEffect(function () {
      var e = s.select(O.current);
      var t = a.zoom().filter(function () {
        return n ? n(s.event) : !!s.event && !s.event.ctrlKey && !s.event.button;
      }).scaleExtent([R, I]).translateExtent([[F, F], [U, W]]).on("start", function () {
        r && !z.current && r({
          coordinates: j.invert(h(M, E, s.event.transform)),
          zoom: s.event.transform.k
        }, s.event);
      }).on("zoom", function () {
        if (!z.current) {
          var e = s.event.transform,
              t = s.event.sourceEvent;
          S({
            x: e.x,
            y: e.y,
            k: e.k,
            dragging: t
          }), c && c({
            x: e.x,
            y: e.y,
            k: e.k,
            dragging: t
          }, s.event);
        }
      }).on("end", function () {
        if (z.current) z.current = !1;else {
          var e = j.invert(h(M, E, s.event.transform)),
              t = l(e, 2),
              o = t[0],
              n = t[1];
          T.current = {
            x: o,
            y: n,
            k: s.event.transform.k
          }, i && i({
            coordinates: [o, n],
            zoom: s.event.transform.k
          }, s.event);
        }
      });
      P.current = t, e.call(t);
    }, [M, E, F, q, U, W, R, I, j, r, c, i, n]), t.useEffect(function () {
      if (k !== T.current.x || b !== T.current.y || g !== T.current.k) {
        var e = j([k, b]),
            t = e[0] * g,
            o = e[1] * g,
            n = s.select(O.current);
        z.current = !0, n.call(P.current.transform, a.zoomIdentity.translate(M / 2 - t, E / 2 - o).scale(g)), S({
          x: M / 2 - t,
          y: E / 2 - o,
          k: g
        }), T.current = {
          x: k,
          y: b,
          k: g
        };
      }
    }, [k, b, g, M, E, j]), {
      mapRef: O,
      position: C,
      transformString: "translate(" + C.x + " " + C.y + ") scale(" + C.k + ")"
    };
  }

  var N = function N(e) {
    var o = e.center,
        n = void 0 === o ? [0, 0] : o,
        r = e.zoom,
        a = void 0 === r ? 1 : r,
        s = e.minZoom,
        l = void 0 === s ? 1 : s,
        f = e.maxZoom,
        p = void 0 === f ? 8 : f,
        m = e.translateExtent,
        v = e.filterZoomEvent,
        h = e.onMoveStart,
        g = e.onMove,
        y = e.onMoveEnd,
        M = e.className,
        E = u(e, ["center", "zoom", "minZoom", "maxZoom", "translateExtent", "filterZoomEvent", "onMoveStart", "onMove", "onMoveEnd", "className"]),
        j = t.useContext(d),
        x = j.width,
        k = j.height,
        N = b({
      center: n,
      filterZoomEvent: v,
      onMoveStart: h,
      onMove: g,
      onMoveEnd: y,
      scaleExtent: [l, p],
      translateExtent: m,
      zoom: a
    }),
        w = N.mapRef,
        C = N.transformString;
    return i.createElement("g", {
      ref: w
    }, i.createElement("rect", {
      width: x,
      height: k,
      fill: "transparent"
    }), i.createElement("g", c({
      transform: C,
      className: "rsm-zoomable-group " + M
    }, E)));
  };

  N.propTypes = {
    center: o.array,
    zoom: o.number,
    minZoom: o.number,
    maxZoom: o.number,
    translateExtent: o.arrayOf(o.array),
    onMoveStart: o.func,
    onMove: o.func,
    onMoveEnd: o.func,
    className: o.string
  };

  var w = function w(e) {
    var o = e.id,
        n = void 0 === o ? "rsm-sphere" : o,
        r = e.fill,
        a = void 0 === r ? "transparent" : r,
        s = e.stroke,
        l = void 0 === s ? "currentcolor" : s,
        f = e.strokeWidth,
        p = void 0 === f ? .5 : f,
        m = e.className,
        v = void 0 === m ? "" : m,
        h = u(e, ["id", "fill", "stroke", "strokeWidth", "className"]),
        g = t.useContext(d).path,
        y = t.useMemo(function () {
      return g({
        type: "Sphere"
      });
    }, [g]);
    return i.createElement(t.Fragment, null, i.createElement("defs", null, i.createElement("clipPath", {
      id: n
    }, i.createElement("path", {
      d: y
    }))), i.createElement("path", c({
      d: y,
      fill: a,
      stroke: l,
      strokeWidth: p,
      style: {
        pointerEvents: "none"
      },
      className: "rsm-sphere " + v
    }, h)));
  };

  w.propTypes = {
    id: o.string,
    fill: o.string,
    stroke: o.string,
    strokeWidth: o.number,
    className: o.string
  };

  var C = t.memo(w),
      S = function S(e) {
    var o = e.coordinates,
        n = e.children,
        r = e.onMouseEnter,
        a = e.onMouseLeave,
        s = e.onMouseDown,
        f = e.onMouseUp,
        p = e.onFocus,
        m = e.onBlur,
        v = e.style,
        h = void 0 === v ? {} : v,
        g = e.className,
        y = void 0 === g ? "" : g,
        M = u(e, ["coordinates", "children", "onMouseEnter", "onMouseLeave", "onMouseDown", "onMouseUp", "onFocus", "onBlur", "style", "className"]),
        E = t.useContext(d).projection,
        j = t.useState(!1),
        x = l(j, 2),
        k = x[0],
        b = x[1],
        N = t.useState(!1),
        w = l(N, 2),
        C = w[0],
        S = w[1],
        T = E(o),
        O = l(T, 2),
        P = O[0],
        z = O[1];
    return i.createElement("g", c({
      transform: "translate(" + P + ", " + z + ")",
      className: "rsm-marker " + y,
      onMouseEnter: function onMouseEnter(e) {
        S(!0), r && r(e);
      },
      onMouseLeave: function onMouseLeave(e) {
        S(!1), k && b(!1), a && a(e);
      },
      onFocus: function onFocus(e) {
        S(!0), p && p(e);
      },
      onBlur: function onBlur(e) {
        S(!1), k && b(!1), m && m(e);
      },
      onMouseDown: function onMouseDown(e) {
        b(!0), s && s(e);
      },
      onMouseUp: function onMouseUp(e) {
        b(!1), f && f(e);
      },
      style: h[k || C ? k ? "pressed" : "hover" : "default"]
    }, M), n);
  };

  S.propTypes = {
    coordinates: o.array,
    children: o.oneOfType([o.node, o.arrayOf(o.node)]),
    onMouseEnter: o.func,
    onMouseLeave: o.func,
    onMouseDown: o.func,
    onMouseUp: o.func,
    onFocus: o.func,
    onBlur: o.func,
    style: o.object,
    className: o.string
  };

  var T = function T(e) {
    var o = e.from,
        n = void 0 === o ? [0, 0] : o,
        r = e.to,
        a = void 0 === r ? [0, 0] : r,
        s = e.coordinates,
        l = e.stroke,
        f = void 0 === l ? "currentcolor" : l,
        p = e.strokeWidth,
        m = void 0 === p ? 3 : p,
        v = e.fill,
        h = void 0 === v ? "transparent" : v,
        g = e.className,
        y = void 0 === g ? "" : g,
        M = u(e, ["from", "to", "coordinates", "stroke", "strokeWidth", "fill", "className"]),
        E = t.useContext(d).path,
        j = {
      type: "LineString",
      coordinates: s || [n, a]
    };
    return i.createElement("path", c({
      d: E(j),
      className: "rsm-line " + y,
      stroke: f,
      strokeWidth: m,
      fill: h
    }, M));
  };

  T.propTypes = {
    from: o.array,
    to: o.array,
    coordinates: o.array,
    stroke: o.string,
    strokeWidth: o.number,
    fill: o.string,
    className: o.string
  };

  var O = function O(e) {
    var o = e.subject,
        n = e.children,
        r = e.connectorProps,
        a = e.dx,
        s = void 0 === a ? 30 : a,
        f = e.dy,
        p = void 0 === f ? 30 : f,
        m = e.curve,
        v = void 0 === m ? 0 : m,
        h = e.className,
        g = void 0 === h ? "" : h,
        y = u(e, ["subject", "children", "connectorProps", "dx", "dy", "curve", "className"]),
        M = (0, t.useContext(d).projection)(o),
        E = l(M, 2),
        j = E[0],
        x = E[1],
        k = function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 30,
          t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 30,
          o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : .5,
          n = Array.isArray(o) ? o : [o, o];
      return "M0,0 Q" + (-e / 2 - e / 2 * n[0]) + "," + (-t / 2 + t / 2 * n[1]) + " " + -e + "," + -t;
    }(s, p, v);

    return i.createElement("g", c({
      transform: "translate(" + (j + s) + ", " + (x + p) + ")",
      className: "rsm-annotation " + g
    }, y), i.createElement("path", c({
      d: k,
      fill: "transparent",
      stroke: "#000"
    }, r)), n);
  };

  O.propTypes = {
    subject: o.array,
    children: o.oneOfType([o.node, o.arrayOf(o.node)]),
    dx: o.number,
    dy: o.number,
    curve: o.number,
    connectorProps: o.object,
    className: o.string
  }, e.Annotation = O, e.ComposableMap = v, e.Geographies = M, e.Geography = j, e.Graticule = k, e.Line = T, e.Marker = S, e.Sphere = C, e.ZoomableGroup = N, e.useGeographies = y, e.useZoomPan = b, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});